(() => {
  'use strict';

  // --- CONFIGURACIÓN ---
  const DEFAULT_FREE_SHIPPING_THRESHOLD = 49.00;
  const ALCOHOL_FREE_SHIPPING_THRESHOLD = 80.00;
  const ALCOHOLIC_KEYWORDS = ['tequila', 'mezcal', 'likör', 'rum', 'bier', 'cerveza', 'vino'];

  // --- FUNCIONES AUXILIARES ---
  function formatCurrency(amount) {
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(amount);
  }

  // --- LÓGICA PRINCIPAL DE LA BARRA DE ENVÍO ---
  function updateShippingBar(cartDrawer) {
    if (!cartDrawer) return;

    // Determinar el umbral de envío
    let containsAlcohol = false;
    const cartItems = cartDrawer.querySelectorAll('.cart-item__name'); // Selector actualizado para temas modernos
    cartItems.forEach(item => {
      const productName = item.textContent.trim().toLowerCase();
      if (ALCOHOLIC_KEYWORDS.some(keyword => productName.includes(keyword))) {
        containsAlcohol = true;
      }
    });
    const freeShippingThreshold = containsAlcohol ? ALCOHOL_FREE_SHIPPING_THRESHOLD : DEFAULT_FREE_SHIPPING_THRESHOLD;

    // Obtener el total del carrito
    const totalsEl = cartDrawer.querySelector('.totals__subtotal-value'); // Selector más fiable que el total
    if (!totalsEl || !totalsEl.textContent) return;

    const totalText = totalsEl.textContent.trim();
    const numberMatch = totalText.match(/[\d,.]+/);
    if (!numberMatch) return;
    const totalValue = parseFloat(numberMatch[0].replace(/\./g, '').replace(',', '.')); // Manejar miles y decimales
    if (isNaN(totalValue)) return;

    // Crear o encontrar el contenedor de la barra
    const cartHeader = cartDrawer.querySelector('.drawer__header');
    if (!cartHeader) return;
    let container = cartDrawer.querySelector('.shipping-progress-container');
    if (!container) {
      container = document.createElement('div');
      container.className = 'shipping-progress-container';
      container.innerHTML = `
        <div class="shipping-progress-text"></div>
        <div class="shipping-progress-bar-wrapper"><div class="shipping-progress-bar"></div></div>
      `;
      cartHeader.parentNode.insertBefore(container, cartHeader.nextSibling);
    }
    
    // Calcular y mostrar el progreso
    const remainingAmount = Math.max(0, freeShippingThreshold - totalValue);
    const progressPercentage = Math.min(100, (totalValue / freeShippingThreshold) * 100);
    const message = remainingAmount > 0
      ? `Noch ${formatCurrency(remainingAmount)} bis zum kostenlosen Versand!`
      : 'Kostenloser Versand erreicht! 🎉';

    container.querySelector('.shipping-progress-text').textContent = message;
    container.querySelector('.shipping-progress-bar').style.width = `${progressPercentage}%`;
  }

  // --- INICIALIZACIÓN SEGURA Y "PEREZOSA" ---
  function initializeWhenCartOpens() {
    const cartDrawer = document.getElementById('CartDrawer');
    if (!cartDrawer) return;

    // 1. Actualizar la barra inmediatamente cuando se abre el carrito
    updateShippingBar(cartDrawer);

    // 2. Crear un observador que SÓLO vigile el interior del carrito
    const cartObserver = new MutationObserver(() => {
      // Usamos un debounce para no ejecutar la función en cada micro-cambio
      clearTimeout(cartDrawer.debounceTimer);
      cartDrawer.debounceTimer = setTimeout(() => updateShippingBar(cartDrawer), 250);
    });

    // 3. Iniciar la observación SÓLO en el nodo del carrito
    cartObserver.observe(cartDrawer, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  // --- DETECTOR DE APERTURA DEL CARRITO ---
  // Escuchamos clics en toda la página para detectar cuándo se abre el carrito.
  document.body.addEventListener('click', (event) => {
    // El selector [aria-controls="CartDrawer"] es el estándar en temas modernos para el icono del carrito.
    if (event.target.closest('[aria-controls="CartDrawer"]')) {
      // Esperar un instante para que la animación del carrito comience
      setTimeout(initializeWhenCartOpens, 100);
    }
  }, true); // Usar captura para asegurar que se ejecute

})();
